import React from 'react';
import { Shield, AlertTriangle, XCircle, Clock } from 'lucide-react';
import { useDarkMode } from '../../context/DarkModeContext';

const ConflictStatusBadge = ({ status, compact = false }) => {
  const { isDarkMode } = useDarkMode();
  const configs = {
    CLEAR: {
      icon: Shield,
      bgLight: 'bg-emerald-100',
      bgDark: 'bg-emerald-900/30',
      textLight: 'text-emerald-700',
      textDark: 'text-emerald-400',
      borderLight: 'border-emerald-200',
      borderDark: 'border-emerald-800',
      label: 'Ingen konflikt'
    },
    PENDING_REVIEW: {
      icon: AlertTriangle,
      bgLight: 'bg-amber-100',
      bgDark: 'bg-amber-900/30',
      textLight: 'text-amber-700',
      textDark: 'text-amber-400',
      borderLight: 'border-amber-200',
      borderDark: 'border-amber-800',
      label: 'Krever vurdering'
    },
    CONFLICT: {
      icon: XCircle,
      bgLight: 'bg-red-100',
      bgDark: 'bg-red-900/30',
      textLight: 'text-red-700',
      textDark: 'text-red-400',
      borderLight: 'border-red-200',
      borderDark: 'border-red-800',
      label: 'Konflikt'
    },
    ESCALATED: {
      icon: Clock,
      bgLight: 'bg-purple-100',
      bgDark: 'bg-purple-900/30',
      textLight: 'text-purple-700',
      textDark: 'text-purple-400',
      borderLight: 'border-purple-200',
      borderDark: 'border-purple-800',
      label: 'Eskalert'
    }
  };

  const config = configs[status] || configs.CLEAR;
  const Icon = config.icon;

  if (compact) {
    return (
      <div className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-lg border ${
        isDarkMode ? `${config.bgDark} ${config.borderDark}` : `${config.bgLight} ${config.borderLight}`
      }`}>
        <Icon className={`w-3.5 h-3.5 ${isDarkMode ? config.textDark : config.textLight}`} />
        <span className={`text-xs font-medium ${isDarkMode ? config.textDark : config.textLight}`}>
          {config.label}
        </span>
      </div>
    );
  }

  return (
    <div className={`inline-flex items-center gap-2 px-3 py-2 rounded-xl border shadow-sm ${
      isDarkMode ? `${config.bgDark} ${config.borderDark}` : `${config.bgLight} ${config.borderLight}`
    }`}>
      <Icon className={`w-5 h-5 ${isDarkMode ? config.textDark : config.textLight}`} />
      <div>
        <div className={`text-sm font-semibold ${isDarkMode ? config.textDark : config.textLight}`}>
          {config.label}
        </div>
      </div>
    </div>
  );
};

export default ConflictStatusBadge;
